module.exports = __webpack_public_path__ + "static/media/Weathervane-bylaws.fb74431f.pdf";